import Vue from 'vue'
import { login, logout, phoneLogin, casLogin, ssoMapLogin, extCasLogin, tokenLogin } from '@/api/login'
import { ACCESS_TOKEN, USER_HALL_INFO, USER_NAME, USER_INFO, USER_AUTH, SYS_BUTTON_AUTH } from '@/store/mutation-types'
import { welcome } from '@/utils/util'
import { queryPermissionsByUser } from '@/api/api'
import { getAction } from '@/api/manage'
import { ACCESS_SECRET } from '../mutation-types'

function submitUser(commit, response) {
  const result = response.result
  const userInfo = result.userInfo
  Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
  Vue.ls.set(ACCESS_SECRET, result.secret, 7 * 24 * 60 * 60 * 1000)
  Vue.ls.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000)
  Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
  commit('SET_TOKEN', result.token)
  commit('SET_SECRET', result.secret)
  commit('SET_ROLE', result.userInfo.roleCode)
  commit('SET_INFO', userInfo)
  commit('SET_NAME', { username: userInfo.username, realname: userInfo.realname, welcome: welcome() })
  commit('SET_AVATAR', userInfo.avatar)
}

const user = {
  state: {
    token: '',
    secret: '',
    username: '',
    realname: '',
    roleCode: '', // agency:代办用户；assistant：帮办用户
    welcome: '',
    avatar: '',
    permissionList: [],
    info: {},
    hallInfo: null
  },

  mutations: {
    initData(state) {
      debugger
      if (!state.token || !state.secret) {
        let token = Vue.ls.get(ACCESS_TOKEN)
        let secret = Vue.ls.get(ACCESS_SECRET)
        if (token && secret) {
          try {
            state.token = token
            state.secret = secret
          } catch (err) {
            Vue.ls.remove(ACCESS_TOKEN)
            Vue.ls.remove(ACCESS_SECRET)
            console.error('init token', err)
          }
        }
      }
      if (!state.hallInfo) {
        let info = Vue.ls.get(USER_HALL_INFO)
        if (info) {
          try {
            state.info = info
          } catch (err) {
            Vue.ls.remove(USER_HALL_INFO)
            console.error('init hallInfo', err)
          }
        }
      }
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_SECRET: (state, secret) => {
      state.secret = secret
    },
    SET_NAME: (state, { username, realname, welcome }) => {
      state.username = username
      state.realname = realname
      state.welcome = welcome
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_PERMISSIONLIST: (state, permissionList) => {
      state.permissionList = permissionList
    },
    SET_INFO: (state, info) => {
      state.info = info
      state.hallInfo = null // 修改用户信息的时候要重置大厅的信息
    },
    SET_HALL_INFO: (state, info) => {
      state.hallInfo = info
      Vue.ls.set(USER_HALL_INFO, info, 7 * 24 * 60 * 60 * 1000)
    },
    SET_ROLE: (state, info) => {
      state.roleCode = info
      console.log(info)
    }
  },

  actions: {
    // CAS验证登录
    ValidateLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        getAction('/cas/client/validateLogin', userInfo).then(response => {
          console.log('----cas 登录--------', response)
          if (response.success) {
            submitUser(commit, response)
            resolve(response)
          } else {
            resolve(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          if (response.code == '200') {
            submitUser(commit, response)
            // commit('openSocket', response.result.userInfo.id , {root: true})
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    tokenLogin({ commit }, tokenInfo) {
      return new Promise((resolve, reject) => {
        tokenLogin().then(response => {
          console.log('tokenLogin ret', response)
          if (response.success && response.result) {
            let userInfo = response.result
            response.result = {
              userInfo,
              token: tokenInfo.token,
              secret: tokenInfo.secret
            }
            submitUser(commit, response)
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    //手机号登录
    PhoneLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        phoneLogin(userInfo).then(response => {
          if (response.code == '200') {
            submitUser(commit, response)
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    ssoMapLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        ssoMapLogin(userInfo).then(response => {
          if (response.success) {
            submitUser(commit, response)
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    casLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        let promise = userInfo.isExt ? extCasLogin(userInfo) : casLogin(userInfo)
        promise.then(response => {
          console.log('casLogin response', response)
          if (response.success) {
            const result = response.result
            const userInfo = result.userInfo
            if (userInfo.id) {
              submitUser(commit, response)
              resolve(response)
            } else {
              resolve(userInfo)
            }
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    GetPermissionList({ commit }) {
      return new Promise((resolve, reject) => {
        let v_token = Vue.ls.get(ACCESS_TOKEN)
        let params = { token: v_token, sysType: 'xzyd' }
        queryPermissionsByUser(params).then(response => {
          const menuData = response.result.menu
          const authData = response.result.auth
          const allAuthData = response.result.allAuth
          sessionStorage.setItem(USER_AUTH, JSON.stringify(authData))
          sessionStorage.setItem(SYS_BUTTON_AUTH, JSON.stringify(allAuthData))
          if (menuData && menuData.length > 0) {
            commit('SET_PERMISSIONLIST', menuData)
          } else {
            reject('getPermissionList: permissions must be a non-null array !')
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    LoadHallInfo({ commit }) {
      return new Promise((resolve, reject) => {
        console.log('send hallInfo request')
        getAction('/sys/sysDepart/getUserDepart', { orgCategory: 2 })
          .then(res => {
            if (res && res.success) {
              console.log('load hall info', res.result)
              commit('SET_HALL_INFO', res.result)
              resolve(res.result)
            } else {
              reject(res.message)
            }
          }).catch(err => {
          console.error(err)
          reject(err)
        })
      })
    },

    // 登出
    Logout({ commit, state }) {
      return new Promise((resolve) => {
        let logoutToken = state.token
        commit('SET_TOKEN', '')
        commit('SET_PERMISSIONLIST', [])
        Vue.ls.remove(ACCESS_TOKEN)
        //console.log('logoutToken: '+ logoutToken)
        logout(logoutToken).then(() => {
          resolve()
        }).catch(() => {
          resolve()
        })
      })
    }

  },
  getters: {
    hallInfo(state) {
      return state.hallInfo
    }
  }
}

export default user